import { render } from "./Male.vue?vue&type=template&id=35a98eaa&scoped=true"
import script from "./Male.vue?vue&type=script&lang=js"
export * from "./Male.vue?vue&type=script&lang=js"

import "./Male.vue?vue&type=style&index=0&id=35a98eaa&scoped=true&lang=css"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35a98eaa"]])

export default __exports__